// Buckets d'ancienneté de dernière offre — source unique partagée entre
// StockVoSuivi.js (filtre + colonne Détail) et StockVoDashboard.js (graphique).
export const OFFER_AGE_BUCKETS = [
  { key: '0-30',    label: '< 30 jours',    test: j => j < 30,                  color: 'var(--color-success)' },
  { key: '30-60',   label: '30-60 jours',   test: j => j >= 30 && j < 60,       color: 'var(--color-warning)' },
  { key: '60-90',   label: '60-90 jours',   test: j => j >= 60 && j < 90,       color: 'var(--color-error)' },
  { key: '90-120',  label: '90-120 jours',  test: j => j >= 90 && j < 120,      color: 'var(--color-error)' },
  { key: '120-360', label: '120-360 jours', test: j => j >= 120,                color: 'var(--color-error)' },
];

// Le dernier bucket numérique (120-360j) n'a pas de plafond réel : il regroupe
// aussi tout ce qui dépasse 360j pour ne perdre aucun véhicule du total.
export const JAMAIS_OFFRE_BUCKET = { key: 'jamais', label: 'Aucune offre', color: 'var(--text-muted)' };

export const ALL_OFFER_AGE_BUCKETS = [...OFFER_AGE_BUCKETS, JAMAIS_OFFRE_BUCKET];

export function getOfferAgeBucket(joursOffre) {
  if (joursOffre === null || joursOffre === undefined) return JAMAIS_OFFRE_BUCKET;
  return OFFER_AGE_BUCKETS.find(b => b.test(joursOffre)) || JAMAIS_OFFRE_BUCKET;
}

// "Dormant" pour les KPI/répartitions agrégées = ≥60j sans offre, ou jamais offert.
export function isDormant(joursOffre) {
  return joursOffre === null || joursOffre === undefined || joursOffre >= 60;
}
